import type { Brand } from "@health/types";

export function BrandLogo({
  brand,
  ...props
}: { brand: Brand } & React.ImgHTMLAttributes<HTMLImageElement>) {
  const src = brand === "hims" ? "/hims-logo.svg" : "/hers-logo.svg";
  return <img src={src} alt={brand} {...props} />;
}
